export default __webpack_public_path__ + "static/media/icon_ellipsis.d4ad4ce5.svg";